import PenIcon from "../../../../assets/icons/Pen";
import Modal from "../../../../components/general/Modal";
import { Container, Content, Header, Button, Description } from "./styles";
import Close from "../../../../assets/icons/Close";
import AccountableWithConfirm from "../../../../components/general/AccountableWithConfirm";
import { useState } from "react";
import CounterButton from "../CounterButton";

/**
 * @typedef {Object} UserFormField
 * @property {{ value: User | undefined, onChange: (value: User) => void }} user
 * @property {{ value: number, onChange: (value: number) => void }} positives
 * @property {{ value: number, onChange: (value: number) => void }} negatives
 * @property {{ value: string, onChange: (value: string) => void }} description
 */

/**
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {(event: React.FormEvent<HTMLFormElement>) => void} props.onSubmit
 * @param {Array<User>} props.users
 * @param {UserFormField} props.form
 * @param {boolean} [props.isEdit]
 * @param {string} [props.title]
 * @param {boolean} [props.disabled]
 * @param {Rdm | null} [props.rdm]
 */

export const RdmUserModal = ({
  title,
  isOpen,
  onClose,
  onSubmit,
  form,
  disabled,
  users,
  rdm,
  isEdit,
}) => {
  const [openSelector, setOpenSelector] = useState(false);

  const availableUsers = users.filter((user) => {
    return !rdm?.rdmUsers.some((rdmUser) => rdmUser.userData._id === user._id);
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <Content>
          <Header>
            <div style={{ display: "flex", alignItems: "center" }}>
              <PenIcon width={20} height={20} />
              <span>{title ?? "Novo Usuário"}</span>
            </div>
            <Close
              style={{
                cursor: "pointer",
                height: "0.95625rem",
                width: "1.3125rem",
              }}
              onClick={onClose}
            />
          </Header>
          <form onSubmit={onSubmit}>
            <AccountableWithConfirm
              id="confirm-input"
              subtitle=""
              placeholder="+ Selecionar Usuário"
              user={[form.user.value, form.user.onChange]}
              open={[openSelector, setOpenSelector]}
              list={availableUsers}
              disabled={isEdit}
            />

            <div style={{ display: "flex", gap: "4rem" }}>
              <CounterButton
                label="Positivos"
                value={form.positives.value}
                onChange={form.positives.onChange}
                min={0}
                color="#1976d2"
              />
              <CounterButton
                label="Negativos"
                value={form.negatives.value}
                onChange={form.negatives.onChange}
                min={0}
                color="#d32f2f"
              />
            </div>

            <Description>
              <span>Notas do Usuário</span>
              <textarea
                value={form.description.value}
                onChange={form.description.onChange}
                maxLength={5000}
                name="TaskDescriptionArea"
                type="text"
              />
            </Description>
            <Button
              disabled={!form.user.value || !form.description.value || disabled}
              type="submit"
            >
              Confirmar
            </Button>
          </form>
        </Content>
      </Container>
    </Modal>
  );
};
